import React from 'react';
import styled from 'styled-components';
import { EditorState, RichUtils, Modifier, genKey, ContentState, ContentBlock } from 'draft-js';

import { Paper, Button, Animation, Dropdown } from 'components'
import { ImageInput, LinkInput } from 'features'
import { FaBold, FaItalic, FaUnderline, FaHighlighter, FaListUl, FaListOl, FaCode, FaPaperclip, FaPlusCircle} from 'react-icons/fa'
import InsertBlock from './InsertBlock'
import InsertOptions from './InsertOptions'

import { addEmptyBlock, getCurrentBlock, addNewBlock } from '../Utils'
import classes from './Toolbar.module.css'
import {codeDefaultProps} from '../Blocks/CodeBlock/CodeBlock'

const Container = styled.div`
    display: flex;
    border-radius: 5px;
    box-sizing: border-box;
    margin-top: 0.2rem;
    width: inherit;
`

const defaultStyles = {
    primaryColor: 'var(--secondary-color)',
    secondaryColor: 'var(--primary-color)',
}

const Toolbar = props => {
    const {
        editorState,
        onToggle,
        disableDropdown,
        styles
    } = props;
    const updatedStyles = Object.assign({}, defaultStyles, styles)

    const BLOCK_TYPES = [
        {label: 'Unordered list', style: 'unordered-list-item', icon:<FaListUl/>},
        {label: 'Numbered list', style: 'ordered-list-item', icon:<FaListOl/>},
    ];

    const INLINE_STYLES = [
        {label: <div className={classes.Tooltip}><div>Bold</div><div className={classes.Code}>Ctrl+B</div></div>, style: 'BOLD', icon: <FaBold/>},
        {label: <div className={classes.Tooltip}><div>Italic</div><div className={classes.Code}>Ctrl+I</div></div>, style: 'ITALIC', icon: <FaItalic/>},
        {label: <div className={classes.Tooltip}><div>Underline</div><div className={classes.Code}>Ctrl+U</div></div>, style: 'UNDERLINE', icon: <FaUnderline/>},
        {label: <div className={classes.Tooltip}><div>Code</div><div className={classes.Code}>Ctrl+E</div></div>, style: 'CODE', icon: <FaCode/>},
        {label: <div className={classes.Tooltip}><div>Highlight</div><div className={classes.Code}>Ctrl+H</div></div>, style: 'HIGHLIGHT', icon: <FaHighlighter/>},

    ];

    const onSelect = (event, type) => {
        event.preventDefault();
        let newState
        if(['BOLD','ITALIC','CODE','UNDERLINE','HIGHLIGHT'].includes(type)){
            console.log('inline')
            newState = RichUtils.toggleInlineStyle(editorState,type);
        } else if (['header-one','header-two','header-three','blockquote','unordered-list-item','ordered-list-item','code-block'].includes(type)){
            console.log('block')
            newState = RichUtils.toggleBlockType(editorState,type);
        } else if (type === 'LINK'){
            newState = onAddLink()
        }
        onToggle(newState)
    }

    const onSelectBlock = (type) => {
        let newState
        const blocks = {
            HEADER_ONE: 'header-one',
            HEADER_TWO: 'header-two',
            HEADER_THREE: 'header-three',
            CODE_BLOCK: 'code-block',
            BLOCKQUOTE: 'blockquote',
            DIVIDER: 'BREAK',
            IMAGE: 'IMAGE',
        }
        if(type === 'CODE_BLOCK'){
            newState = addNewBlock(editorState, blocks[type], codeDefaultProps)
        } else {
            newState = RichUtils.toggleBlockType(editorState,blocks[type]);
        }
        newState = addEmptyBlock(newState)
        onToggle(newState)
    }

    // Constants
    const selection = editorState.getSelection();
    const blockType = getCurrentBlock(editorState).getType()
    // const blockType = editorState.getCurrentContent()
    //                             .getBlockForKey(selection.getStartKey())
    //                             .getType();
    const currentStyle = editorState.getCurrentInlineStyle();

    // Construction
    let blocks = []
    const activeStyle = {
        backgroundColor: updatedStyles['primaryColor'],
        color: 'var(--text-color)',
        margin: 0,
        padding: '0.5rem',
        boxShadowColor: 'transparent'
    }

    const onAddLink = (link) => {
        const selection = editorState.getSelection();
        if (!link) {
            return RichUtils.toggleLink(editorState, selection, null);
        }
        const content = editorState.getCurrentContent();
        const contentWithEntity = content.createEntity("LINK", "MUTABLE", {
            url: link
        });
        const newEditorState = EditorState.push(
            editorState,
            contentWithEntity,
            "create-entity"
        );
        const entityKey = contentWithEntity.getLastCreatedEntityKey();
        onToggle(RichUtils.toggleLink(newEditorState, selection, entityKey))
    };

    const inactiveStyle = {
        backgroundColor: updatedStyles['primaryColor'],
        color: 'var(--secondary-accent-color)',
        margin: 0,
        padding: '0.5rem',
        boxShadowColor: 'transparent'
    }
        
    INLINE_STYLES.map(type => {
        blocks.push(<Button icon={type.icon} tooltip={type.label} onSelect={(event) => onSelect(event, type.style)} styles={currentStyle.has(type.style) ? activeStyle : inactiveStyle}/>)
    })

    BLOCK_TYPES.map(type => {
        blocks.push(<Button icon={type.icon} tooltip={type.label} onSelect={(event) => onSelect(event, type.style)} styles={type.style === blockType ? activeStyle : inactiveStyle}/>)
    })
    blocks.push(<Button icon={<FaPaperclip/>} tooltip='Link' styles={inactiveStyle} placement='bottom-end'  
                    contextMenu={<LinkInput onSubmit={onAddLink}/>} />)
    
    return (
        <Container>
            {/* <InsertBlock onSelect={onSelectBlock} disableDropdown={disableDropdown} styles={{primaryColor: updatedStyles.secondaryColor}}/> */}
            <Button icon={<FaPlusCircle/>} tooltip='New block' styles={inactiveStyle} 
                contextMenu={<InsertOptions onSelect={onSelectBlock} styles={{primaryColor: updatedStyles.secondaryColor}}/>}/>
            {blocks}
        </Container>
    )
}

export default Toolbar;